function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import KZUIComponent from '../base/index';
import { validateHEX, validateRGB, validateA, HEXToRGB, RGBToHEX, formatHEX } from './color-utils';

var ColorInput = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(ColorInput, _KZUIComponent);

  var _super = _createSuper(ColorInput);

  function ColorInput(props) {
    var _this;

    _classCallCheck(this, ColorInput);

    _this = _super.call(this, props);

    _this.autoBind('handleRGBChange', 'handleAChange', 'handleHEXChange', 'triggerChange');

    return _this;
  }

  _createClass(ColorInput, [{
    key: "initStateFromProps",
    value: function initStateFromProps(props) {
      return {
        hex: props.hex,
        rgb: props.rgb,
        a: props.a
      };
    }
  }, {
    key: "handleHEXChange",
    value: function handleHEXChange(e) {
      var hex = formatHEX(e.target.value);

      if (validateHEX(hex)) {
        var rgb = HEXToRGB(hex);
        this.setState({
          hex: hex,
          rgb: rgb
        });
        this.triggerChange(rgb, hex, this.state.a);
      } else {
        this.setState({
          hex: hex
        });
      }
    }
  }, {
    key: "handleRGBChange",
    value: function handleRGBChange(e) {
      var name = e.target.name;
      var value = e.target.value ? parseInt(e.target.value, 10) : 0;

      var rgb = _toConsumableArray(this.state.rgb);

      switch (name) {
        case 'r':
          rgb[0] = value;
          break;

        case 'g':
          rgb[1] = value;
          break;

        case 'b':
          rgb[2] = value;
          break;

        default:
          return;
      }

      var hex = RGBToHEX(rgb);

      if (validateRGB(rgb)) {
        this.setState({
          hex: hex,
          rgb: rgb
        });
        this.triggerChange(rgb, hex, this.state.a);
      }
    }
  }, {
    key: "handleAChange",
    value: function handleAChange(e) {
      var value = parseInt(e.target.value, 10) || 0;

      if (validateA(value)) {
        this.setState({
          a: value
        });
        this.triggerChange(this.state.rgb, this.state.hex, value);
      }
    }
  }, {
    key: "triggerChange",
    value: function triggerChange(rgb, hex, a) {
      if (this.props.onChange) {
        this.props.onChange(rgb, hex, a);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var clsPrefix = 'kui-color-picker';
      var cls = classNames("".concat(clsPrefix, "-input"));
      return /*#__PURE__*/React.createElement("div", {
        className: cls
      }, this.props.type === 'simple' ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-cin-simple")
      }, /*#__PURE__*/React.createElement("input", {
        className: "".concat(clsPrefix, "-cin-input"),
        type: "text",
        name: "hex",
        value: this.state.hex,
        onChange: this.handleHEXChange
      })) : /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-cin-full ").concat(clsPrefix, "-clear")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-cin-full-cell ").concat(clsPrefix, "-cin-full-hex")
      }, /*#__PURE__*/React.createElement("input", {
        className: "".concat(clsPrefix, "-cin-input ").concat(clsPrefix, "-cin-input-small"),
        name: "hex",
        type: "text",
        value: this.state.hex,
        onChange: this.handleHEXChange
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-cin-full-txt")
      }, "HEX")), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-cin-full-cell ").concat(clsPrefix, "-cin-full-rgba")
      }, /*#__PURE__*/React.createElement("input", {
        className: "".concat(clsPrefix, "-cin-input ").concat(clsPrefix, "-cin-input-small"),
        type: "text",
        name: "r",
        value: this.state.rgb[0],
        onChange: this.handleRGBChange
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-cin-full-txt")
      }, "R")), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-cin-full-cell ").concat(clsPrefix, "-cin-full-rgba")
      }, /*#__PURE__*/React.createElement("input", {
        className: "".concat(clsPrefix, "-cin-input ").concat(clsPrefix, "-cin-input-small"),
        name: "g",
        type: "text",
        value: this.state.rgb[1],
        onChange: this.handleRGBChange
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-cin-full-txt")
      }, "G")), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-cin-full-cell ").concat(clsPrefix, "-cin-full-rgba")
      }, /*#__PURE__*/React.createElement("input", {
        className: "".concat(clsPrefix, "-cin-input ").concat(clsPrefix, "-cin-input-small"),
        name: "b",
        type: "text",
        value: this.state.rgb[2],
        onChange: this.handleRGBChange
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-cin-full-txt")
      }, "B")), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-cin-full-cell ").concat(clsPrefix, "-cin-full-rgba")
      }, /*#__PURE__*/React.createElement("input", {
        className: "".concat(clsPrefix, "-cin-input ").concat(clsPrefix, "-cin-input-small"),
        name: "a",
        type: "text",
        value: this.state.a,
        onChange: this.handleAChange
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-cin-full-txt")
      }, "A"))));
    }
  }]);

  return ColorInput;
}(KZUIComponent);

ColorInput.defaultProps = {
  type: 'simple',
  hex: '#f00',
  rgb: [255, 0, 0],
  a: 100
};
ColorInput.propTypes = {
  type: PropTypes.string,
  hex: PropTypes.string,
  rgb: PropTypes.arrayOf(PropTypes.number),
  a: PropTypes.number
};
export default ColorInput;